import html2canvas from 'html2canvas';

export const downloadCardImage = async (card, title) => {
  if (!card) return;
  try {
    const poster = card.querySelector('img');
    if (poster && !poster.complete) {
      await new Promise((res) => (poster.onload = res));
    }
    const originalStyle = { animation: card.style.animation, opacity: card.style.opacity };
    card.style.animation = 'none';
    card.style.opacity = '1';
    const canvas = await html2canvas(card, { useCORS: true, backgroundColor: null });
    const image = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = image;
    link.download = `${title}-card.png`;
    link.click();
    card.style.animation = originalStyle.animation;
    card.style.opacity = originalStyle.opacity;
  } catch (error) {
    console.error('Failed to download card image:', error);
  }
};
